import ReceiptDialog from './ReceiptDialog';
import './style/receipt-dialog.less';

export default ReceiptDialog;
